/************************************
MODULE:         Loadmore list
WHAT IT DOES:   Initializes lists that have loadmore button functionality
*************************************/
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    }
    else if (typeof exports === 'object') {
        module.exports = factory(require('jquery'));
    }
    else { root.returnExports = factory(root.jQuery); }
}(this, function ($) {

    function init() {
        var loadlist = $('.js-loadlist');
        if (!loadlist.length)
            return;

        var genericloadlist = require('generic.loadlist');

        for (var i = 0, l = loadlist.length; i < l; i++) {
            new genericloadlist(loadlist.eq(i));
        }
    }

    return {
        init: init
    };

}));


/*****************
 ** WEBPACK FOOTER
 ** ./js/app/modules/app.loadlist.js
 ** module id = 43
 ** module chunks = 24
 **/